import { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { deleteToken, useAppContext } from "utils/store";

export default function FireOnHeader({
  currentDateTime,
  handleSound,
  isAllowedSound,
}) {
  const navigate = useNavigate();
  const {
    store: { userName },
    dispatch,
  } = useAppContext();

  const handleLogout = () => {
    if (window.confirm("로그아웃하시겠습니까?")) {
      dispatch(deleteToken());
      navigate("/");
    }
  };

  return (
    <div className="wrap_right pc">
      <div className="wrap_userBox">
        <div className="wrap_userInfo pc">
          <p className="current_date">{currentDateTime}</p>
        </div>
        <p className="user_id">{userName}</p>
      </div>
      <div className="user_contr">
        {handleSound && (
          <button className="btn_contr btn_sound pc" onClick={handleSound}>
            <i className="x-icon">{`${isAllowedSound ? "" : ""}`}</i>
          </button>
        )}
        <button className="btn_contr btn_home pc" onClick={() => navigate("/")}>
          <i className="x-icon"></i>
        </button>
        <button
          to=""
          className="btn_contr btn_logout pc"
          onClick={handleLogout}
        >
          <i className="x-icon"></i>
        </button>
      </div>
    </div>
  );
}
